import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronLeft } from 'lucide-react';

export function BackHeader({ title }: { title: string }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-3 py-2 mb-2">
      <button
        type="button"
        onClick={() => navigate(-1)}
        aria-label={t('common.back')}
        className="rounded-full w-9 h-9 inline-flex items-center justify-center transition-colors"
        style={{
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid var(--line-2)',
          color: 'var(--text-1)',
        }}
      >
        <ChevronLeft size={18} strokeWidth={1.75} />
      </button>
      <h1 className="headline text-[18px] uppercase tracking-[0.02em]">{title}</h1>
    </div>
  );
}
